<template>
  <ComDialog
    :isShow="dialogVisible"
    :width="800"
    title="应用黑名单明细"
    alignCenter
    @close="handleClose"
  >
    <comTable
      :tableItem="basicInfo"
      :tableData="basicInfoData"
      style="min-height: 200px; max-height: 500px"
    ></comTable>
  </ComDialog>
</template>
<script setup>
import { ref, defineExpose } from "vue";
import ComDialog from "@/components/comDialog/index.vue";
import request from "@/utils/request.ts";
import API_CONFIG from "../api.json";
import { getDictLabel } from "@/utils/index.ts";
const basicInfo = ref([
  { label: "应用名称", prop: "appName" },
  { label: "应用包名", prop: "appPackage" },
  {
    label: "黑名单应用类型",
    prop: "type",
    valueFormatter: ({ value }) => {
      return getDictLabel("APP_BLACKLIST_TYPE", value);
    },
  },
  {
    label: "启用状态",
    prop: "status",
    valueFormatter: ({ value }) => {
      return value == 0 ? "生效" : "失效";
    },
    cellStyle: ({ value }) => ({ color: value == 0 ? "green" : "" }),
  }
]);
const basicInfoData = ref([]);
const currentDevice = ref({});
const dialogVisible = ref(false);
const open = (data) => {
  currentDevice.value = data;
  dialogVisible.value = true;
  getAppListById();
};

const getAppListById = () => {
  request
    .post(API_CONFIG.queryAppBlacklist.url + `/${currentDevice.value.code}`)
    .then((res) => {
      if (res.code == 200) {
        basicInfoData.value = res.data.localList.concat(res.data.passList).filter(ele=>ele.status==0);
      }
    });
};

const handleClose = () => {
  dialogVisible.value = false;
};
defineExpose({ open });
</script>
